import React, { Component } from 'react';
import axios from 'axios';
import { connect } from 'react-redux';
import swal from 'sweetalert2';

import './Form.css';
import { updateInput, reset } from '../../ducks/reducer';

class Form extends Component {
  state = {
    form: false,
    password: '',
    validate: false,
    error: false
  };

  componentDidMount() {
    window.scroll({ top: 0, behavior: 'smooth' });
  }

  password = () => {
    const { password } = this.state;

    axios
      .put('/api/user', { password })
      .then(res => {
        this.setState({ form: res.data.test });
      })
      .catch(() => {
        this.setState({ error: true });
      });
  };

  handleCode = e => this.setState({ password: e.target.value });

  handleClick = () => this.password();

  handleKeyDown = e => e.keyCode === 13 && this.password();

  handleSubmit = e => {
    let {
      firstName,
      lastName,
      department,
      position,
      isd,
      school,
      email,
      phoneNumber,
      instrument
    } = this.props;

    axios
      .post(`/api/position`, {
        first_name: firstName,
        last_name: lastName,
        department,
        position,
        isd,
        school,
        email,
        work_phone: phoneNumber,
        instrument
      })
      .then(res => {
        swal({
          position: 'bottom-end',
          title: 'Success!',
          text: 'Your submission is under review',
          background: '#dbdbdb',
          showConfirmButton: false,
          timer: 1500
        });
      })
      .then(res => {
        this.props.history.push('/');
        this.props.reset();
      });
  };

  formInput = (text, name, display) => {
    return (
      <label className="has-float-label">
        <input
          required
          className="input_field"
          type="text"
          placeholder={text}
          name={name}
          onChange={e => this.props.updateInput(e)}
        />
        <span id="ce_title">{display || text}</span>
      </label>
    );
  };

  render() {
    const {
      updateInput,
      firstName,
      lastName,
      department,
      position,
      isd,
      school,
      email,
      phoneNumber,
      instrument
    } = this.props;
    const { form, validate, error } = this.state;

    return (
      <div className="form_container">
        <div className="component_img" />

        {!form && (
          <div className="form_verify_cont">
            <div className="form_sub">
              <h1>This area is Protected</h1>
              <div className="form_content">
                <p>Please enter the password below.</p>
                <div className="password_form">
                  <input
                    autoFocus
                    type="password"
                    onChange={this.handleCode}
                    onKeyDown={this.handleKeyDown}
                  />
                  <h2 onClick={() => this.handleClick()}>Login</h2>
                </div>
              </div>
              {error && (
                <p className="verification">
                  **This password is not correct. Please try again.
                </p>
              )}
            </div>
          </div>
        )}

        {form && (
          <div className="form_sub">
            <h1>Director Information Form</h1>
            <div className="form_content">
              {this.formInput('First Name', 'firstName')}
              {this.formInput('Last Name', 'lastName')}

              <div className="form_dropdown">
                <select
                  className="styled-select slate"
                  name="department"
                  onChange={e => updateInput(e)}
                >
                  <option>Choose a Department</option>
                  <option>Band</option>
                  <option>Choir</option>
                  <option>Orchestra</option>
                  <option>Mariachi</option>
                </select>
                <select
                  className="styled-select slate"
                  name="position"
                  onChange={e => updateInput(e)}
                >
                  <option>Choose a Position</option>
                  <option>Head Director</option>
                  <option>Assistant Director</option>
                </select>
              </div>
              {this.formInput('ISD', 'isd')}
              {this.formInput('School', 'school')}
              {this.formInput(
                'Email@gmail.com',
                'email',
                'Primary Contact E-mail'
              )}
              {this.formInput(
                '(555) - 555 - 5555',
                'phoneNumber',
                'Work Phone Number'
              )}
              {this.formInput('Percussion', 'instrument', 'Primary Instrument')}
            </div>
            {validate && (
              <p className="verification">*Please complete each field </p>
            )}
            <div className="form_btn_holder">
              {!firstName ||
              !lastName ||
              !department ||
              !position ||
              !isd ||
              !school ||
              !email ||
              !phoneNumber ||
              !instrument ? (
                <button
                  className="form_btn"
                  onClick={() => this.setState({ validate: true })}
                >
                  Submit
                </button>
              ) : (
                <button
                  className="form_btn"
                  onClick={e => this.handleSubmit(e)}
                >
                  Submit
                </button>
              )}
            </div>
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = state => state;

export default connect(
  mapStateToProps,
  {
    updateInput,
    reset
  }
)(Form);



// WEBPACK FOOTER //
// ./src/Components/Form/Form.js